import {
  BorderRadius,
  Spacing,
  fontFamily,
  Colors,
  Text,
} from '@doordash/design-language'

export const VGS_DOC_UPLOAD_CSS = {
  width: '100%',
  height: '100%',
  position: 'absolute',
  input: {
    display: 'none',
  },
}

type VGSCompareType = {
  type: string
  params: {
    field: string
    function: string
  }
}

export const ssnFieldProps = fieldName => {
  // Text.Weights.Medium returns a string but VGS wants a number
  const VGS_MEDIUM_FONT_WEIGHT = 500
  const ssnFieldStyles = {
    boxSizing: 'border-box',
    fontSize: Spacing.Small,
    fontWeight: VGS_MEDIUM_FONT_WEIGHT,
    lineHeight: Text.LineHeights.Large,
    backgroundColor: Colors.SystemGrey0,
    padding: `${Spacing.XxSmall}px ${Spacing.Small}px`,
    borderRadius: BorderRadius.FieldsInputDefault,
    fontFamily,
    '&:focus': {
      boxShadow: `${Colors.SystemBlack} 0 0 0 2px inset`,
    },
  }

  const validations: (string | VGSCompareType)[] = ['required', 'validSSN']
  const confirmSSNValidation: VGSCompareType = {
    type: 'compareValue',
    params: {
      field: 'ssn',
      function: 'match',
    },
  }

  if (fieldName == 'ssnConfirm') {
    validations.push(confirmSSNValidation)
  }
  return {
    type: 'ssn',
    name: fieldName,
    placeholder: '000-00-0000',
    validations,
    css: ssnFieldStyles,
    serializers: [{ name: 'replace', options: { old: '-', new: '' } }],
    hideValue: false,
  }
}
